/**
 * ツールチップのマウスオーバー表示制御を初期化する
 */
// ツールチップ(マウスオン)
$(function(){
  $(".js-tooltip").on({
	/**
	 * マウスエンター時にツールチップを表示する
	 */
	// js-tooltipの子孫要素のtooltipBoxのみを出し分けする
	'mouseenter':function(){
		$(this).find(".tooltipBox").toggle();
    },
  /**
   * マウスリーブ時にツールチップを非表示にする
   */
  'mouseleave':function(){
		$(this).find(".tooltipBox").toggle();
  }});
	return false;
});

// ブランド名にマウスオーバーした時の処理
var timeoutId=null;
var imgToggleFunction;
/**
 * ブランドリンクのマウスオーバー時の画像表示制御を初期化する
 */
$(function(){
	$(document).on({
		/**
		 * マウスエンター時に遅延表示処理を設定する
		 */
		mouseenter: function() {
			// マウスが要素に入ったときの処理
			//	既にtimeoutIdにセットされている場合は消す
			if(timeoutId !== null){
				clearTimeout(timeoutId);
				timeoutId = null;
			}
			//	時限式で動かしたいfunctionをセットする
			imgToggleFunction = function (jukuId){
				var jukuLinkBImg = '.js-juku-link-block-img' + jukuId;
				$(jukuLinkBImg).toggle();
				timeoutId = null
			};
			var setJukuId = $(this).attr('juku_id');
			//	マウスオーバーして210ms後に動かす
			timeoutId = setTimeout(function(){imgToggleFunction(setJukuId)} , 160);
		},
		/**
		 * マウスリーブ時に画像を非表示にする
		 */
		mouseleave: function() {
			// マウスが要素から出たときの処理
			//	時限式の待ち時間があるなら消す
			if(timeoutId !== null){
				clearTimeout(timeoutId);
				timeoutId = null;
			} else {
			//	時限式の待ち時間が過ぎていた場合は表示されるので画像を消す
				var jukuLinkBImg = '.js-juku-link-block-img' + $(this).attr('juku_id');
				$(jukuLinkBImg).toggle();
			}
		}
	}, '.js-brand-link');
	return false;
});

// ブランド名にマウスオーバーした時の処理
// 関数を全体で定義する(setTimeoutはグローバル関数でないと動かないため)
let kbImgToggleFunction;
/**
 * KBブランドリンクのマウスオーバー時の画像表示制御を初期化する
 */
$(function(){
	let kbTimeoutId=null;

	$(".js-kb-brand-link").on({
	/**
	 * マウスエンター時に遅延表示処理を設定する
	 */
	'mouseenter':function(){
		//	既にtimeoutIdにセットされている場合は消す
		if(kbTimeoutId !== null){
			clearTimeout(kbTimeoutId);
			kbTimeoutId = null;
		}
		//	時限式で動かしたいfunctionをセットする
		kbImgToggleFunction = function (jukuId){
			let jukuLinkBImg = '.js-kb-juku-link-block-img' + jukuId;
			$(jukuLinkBImg).toggle();
			kbTimeoutId = null
		};
		let setJukuId = $(this).attr('kb_juku_id');
		//	マウスオーバーして210ms後に動かす
		kbTimeoutId = setTimeout( "kbImgToggleFunction(" + setJukuId + ")", 160);
	},
	/**
	 * マウスリーブ時に画像を非表示にする
	 */
	'mouseleave':function(){
		//	時限式の待ち時間があるなら消す
		if(kbTimeoutId !== null){
			clearTimeout(kbTimeoutId);
			kbTimeoutId = null;
		} else {
		//	時限式の待ち時間が過ぎていた場合は表示されるので画像を消す
			let jukuLinkBImg = '.js-kb-juku-link-block-img' + $(this).attr('kb_juku_id');
			$(jukuLinkBImg).toggle();
		}
	}});
	return false;
});
